import {useEffect, useState} from 'react';
import {Alert, Stack, Text} from '@mantine/core';
import {Account} from '../../accounts/types';
import {checkMultipleAccountSessions} from '../../account-sessions/services/AccountSessionService';
import {AccountSessionInfo} from '../../account-sessions/types';

interface SessionDebugInfoProps {
    accounts: Account[];
}

export const SessionDebugInfo = ({accounts}: SessionDebugInfoProps) => {
    const [sessionsInfo, setSessionsInfo] = useState<AccountSessionInfo[]>([]);

    useEffect(() => {
        const checkSessions = async () => {
            if (accounts.length === 0) {
                setSessionsInfo([]);
                return;
            }

            const results = await checkMultipleAccountSessions(accounts);
            setSessionsInfo(results);
        };

        checkSessions();
    }, [accounts]);

    if (sessionsInfo.length === 0) return null;

    return (
        <Stack gap="md">
            {sessionsInfo.map((info) => (
                <Alert key={info.accountId} color={info.isActive && !info.isExpired ? 'green' : 'red'}>
                    <Stack gap="xs">
                        <Text size="sm" fw={500}>Session: {info.email}</Text>
                        <Text size="xs">Active: {info.isActive ? 'Yes' : 'No'}</Text>
                        <Text size="xs">Token Expired: {info.isExpired ? 'Yes' : 'No'}</Text>
                        {info.expiresAt && (
                            <Text size="xs">Expires: {info.expiresAt.toLocaleString()}</Text>
                        )}
                    </Stack>
                </Alert>
            ))}
        </Stack>
    );
};
